var SENTRY_RELEASE;SENTRY_RELEASE={name: "EMO.coach ProofTree", version: "1.0.0"};